import { Actions } from '../../interfaces'
import { Appraisal } from '@/entities/purchase'

import create from './create'
import fetch from './fetch'
import update from './update'
import find from './find'
import findFull from './findFull'

export const actions: Actions = {
  create,
  fetch,
  update,
  find,
  findFull,
}

export default {
  Model: { Appraisal },
  actions: { [Appraisal.name]: actions },
}
